// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "../static-" + (["1.12461"][{"9217":0}[chunkId]] || "1.12464") + "/" + chunkId + ".js";
};